<div class="popup-container">
  <div class="popup-model">
    <div class="popup-header">
      <div class="popup-header-text">{{ headerTitle }}</div>
      <div class="popup-close" (click)="close()" title="Close"></div>
    </div>
    <div class="popup-body">
      <div class="users-container">
  <div class="user-form" *ngFor="let user of users; let i = index">
          <div class="user-form-header">
            <div class="user-form-title">User {{ i + 1 }}</div>
            <div class="user-actions">
              <div class="minimize-user-btn" (click)="toggleMinimize(i)" title="Toggle minimize">
                <div class="minimize-icon" [ngClass]="{ 'collapsed': user.collapsed }"></div>
              </div>
              <div class="remove-user-btn" *ngIf="users.length > 1" (click)="removeUser(i)" title="Remove User">
                <div class="delete-icon"></div>
              </div>
            </div>
          </div>
          <div class="form-container" [ngClass]="{ 'collapsed': user.collapsed }">
            <div class="form-group">
              <label class="form-label">First Name <span class="required">*</span></label>
              <input 
                type="text" 
                class="form-input" 
                [(ngModel)]="user.firstName" 
                placeholder="Enter first name"
                maxlength="100"
              />
            </div>
            <div class="form-group">
              <label class="form-label">Last Name </label>
              <input 
                type="text" 
                class="form-input" 
                [(ngModel)]="user.lastName" 
                placeholder="Enter last name"
                maxlength="100"
              />
            </div>
            <div class="form-group">
              <label class="form-label">Email(all letters to be in small letters ) <span class="required">*</span></label>
              <input 
                type="email" 
                class="form-input" 
                [(ngModel)]="user.email" 
                placeholder="Enter email address"
                maxlength="150"
              />
              <div class="error-message" *ngIf="user.email.trim() !== '' && !isValidEmail(user.email.trim())">
                Please enter a valid email address
              </div>
            </div>
          </div>
        </div>
        <div 
          class="add-user-btn" 
          [ngClass]="{ 'disabled': !canAddUser }" 
          (click)="tryAddUser()"
          [title]="canAddUser ? 'Add Another User' : 'Fill required fields for existing users first'"
        >
          <div class="add-icon"></div>
          <div class="add-text">Add Another User</div>
        </div>
      </div>
    </div>
    <div class="popup-footer">
      <div class="form-validation-summary" *ngIf="!isFormValid && hasAttemptedSubmit">
        <div class="validation-error">Please fill all required fields for all users</div>
      </div>
      <div class="popup-footer-buttons">
        <div 
          class="popup-btn" 
          [ngClass]="{ 'disabled': !isFormValid }" 
          (click)="onSubmit()"
          [title]="isFormValid ? 'Add Users' : 'Please fill all required fields'"
        >
          <div class="btn-text">Add {{ users.length > 1 ? users.length + ' Users' : 'User' }}</div>
        </div>
        <div class="popup-btn" (click)="onCancel()">
          <div class="btn-text">Cancel</div>
        </div>
      </div>
    </div>
  </div>
</div>
